export const mutations = {
    SET_LIST: (state, users) => (state.list = users),
};
